// src/assets/components/NotFound.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/NotFound.css';

const NotFound = () => {
    return (
        <section className="notfound-container">
            <h1>404</h1>
            <p>Página não encontrada</p>
            <Link to="/" className="btn">
                Voltar para o início
            </Link>
        </section>
    );
};

export default NotFound;
